import { appEnvSchema } from '@/types/env';

export const env = appEnvSchema.parse(import.meta.env);
